import { InjectionToken } from '@angular/core';
import { TranslocoMessageService } from '@bbraun/shared/util-transloco-message';

export const UI_LOGIN_MESSAGE_SERVICE =
  new InjectionToken<TranslocoMessageService>('UI_LOGIN_MESSAGE_SERVICE');
